export default "__VITE_ASSET__3ddca3db__"